import React from 'react';
import styles from '../Page404/Page404.module.css';

export const Page404 = () => {
  return (
    <div className={styles.text404}>
      <h1>Error 404!!! Page not found</h1>
    </div>
  );
};
